// extracted by mini-css-extract-plugin
module.exports = {"button":"actionButton_button__H_KtY","label":"actionButton_label__V5HdW","icon":"actionButton_icon__4Fckx","shine":"actionButton_shine__QIEsa"};